import React from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { ArrowLeft, Mail, BadgeCheck, Calendar } from "lucide-react";
import { studioAuth } from "../lib/studioApi";
import Avatar from "../components/studio/Avatar";
import { Button } from "../components/ui/button";

function safeDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString();
  } catch {
    return "—";
  }
}

export default function StudioProfile() {
  const ctx = useOutletContext() || {};
  const navigate = useNavigate();
  const me = ctx.me || studioAuth.getUser() || {};

  return (
    <div data-testid="studio-profile-page" className="max-w-2xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <button
          type="button"
          onClick={() => navigate("/studio")}
          className="text-white/60 hover:text-white"
          aria-label="Back"
          data-testid="studio-profile-back"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
        <h1 className="text-3xl font-extrabold text-white">Your Profile</h1>
      </div>

      <div className="bg-[#10162a] border border-white/5 rounded-2xl p-8">
        <div className="flex flex-col sm:flex-row items-start gap-6">
          <Avatar user={me} size="xl" testIdPrefix="studio-profile-avatar" />
          <div className="flex-1 min-w-0">
            <h2 className="text-2xl font-extrabold text-white" data-testid="studio-profile-name">
              {me.artistName || me.name || "—"}
            </h2>
            {me.artistName && me.name && me.artistName !== me.name && (
              <p className="text-sm text-white/50 mt-1">Real name: {me.name}</p>
            )}

            <div className="mt-6 space-y-3 text-sm">
              <div className="flex items-center gap-3 text-white/70">
                <Mail className="w-4 h-4 text-paul-yellow" />
                <span data-testid="studio-profile-email">{me.email}</span>
              </div>
              <div className="flex items-center gap-3 text-white/70">
                <BadgeCheck className="w-4 h-4 text-paul-yellow" />
                <span data-testid="studio-profile-status">{me.status || "—"}</span>
              </div>
              <div className="flex items-center gap-3 text-white/70">
                <Calendar className="w-4 h-4 text-paul-yellow" />
                <span data-testid="studio-profile-joined">Joined {safeDate(me.createdAt)}</span>
              </div>
            </div>

            <Button
              data-testid="studio-profile-edit-btn"
              onClick={() => navigate("/studio/settings")}
              className="mt-6 bg-paul-yellow hover:bg-paul-yellow text-navy font-bold"
              style={{ color: "#0b1535" }}
            >
              Edit profile
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
